import { css } from "lit";

export const dropdownMenuStyles = css`
  :host {
    position: relative;
    display: inline-block;
  }

  .dropdown-container {
    position: relative;
  }

  .dropdown-trigger {
    background: none;
    border: none;
    padding: 0;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    width: var(--dropdown-trigger-width, auto);
  }

  .dropdown-trigger:focus-visible {
    outline: var(--sds-size-stroke-focus-ring) solid var(--sds-color-border-default-default);
    outline-offset: 2px;
  }

  .dropdown-trigger:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  .dropdown-content {
    position: fixed;
    background: var(--sds-color-background-default-default);
    border: var(--sds-size-stroke-border) solid var(--sds-color-border-default-default);
    border-radius: var(--sds-size-radius-400);
    box-shadow: 0 4px 12px rgb(0 0 0 / 0.15);
    padding: var(--sds-size-space-200);
    min-width: 120px;
    margin: 0;
    z-index: 1000;
    animation: dropdownAppear 0.15s ease-out;
  }

  .dropdown-content[hidden] {
    display: none;
  }

  /* Dark theme background */
  [data-theme="dark"] .dropdown-content {
    background: var(--sds-color-gray-800);
    box-shadow: 0 4px 12px rgb(0 0 0 / 0.3);
  }

  @keyframes dropdownAppear {
    from {
      opacity: 0;
      transform: translateY(-4px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  /* Active state when dropdown is open */
  :host([open="true"]) .dropdown-trigger {
    background-color: var(--sds-color-background-neutral-secondary);
  }
`;
